function extend(app, mixin) {
  if (!app.mixins) {
    app.mixins = [];
  }
  app.mixins.push(mixin);
}
// eslint-disable-next-line space-before-function-paren
export default async function ({ app }) {
  await extend(app, {
    mounted() {
      if (!window.__logoutChannelInitialized) {
        const channel = new BroadcastChannel('ofix-app');

        // Czy karta ma pełen fokus?
        window.__isFocused = document.hasFocus();

        // Nasłuchiwanie zmian fokusów
        window.addEventListener('focus', () => {
          window.__isFocused = true;
        });

        window.addEventListener('blur', () => {
          window.__isFocused = false;
        });

        channel.onmessage = event => {
          const { type } = event.data || {};

          if (type === 'LOGOUT' || type === 'LOGIN') {
            if (!window.__isFocused) {
              window.location.reload();
            } else {
              console.log(`[ofix-app] Karta jest aktywna (focus), nie odświeżam.`);
            }
          }
        };

        window.__logoutChannel = channel;
        window.__logoutChannelInitialized = true;

        // eslint-disable-next-line space-before-function-paren
        window.sendLoginOrLogoutMessage = function (type) {
          channel.postMessage({ type });
        };
      }
    },
  });
}
